module.exports = __webpack_public_path__ + "static/Expertise-534b66941159cb56d4f3adb207e2d18f.png";